'use es6';

import { resolveReport } from './resolve';
import SalesAnalyticsReport from '../lib/salesAnalytics/SalesAnalyticsReport';
import TransposedTableVisualization from '../lib/salesAnalytics/TransposedTableVisualization';
import { inferVisualization } from 'reporting-ui-components/reports/inferLogic/inferVisualization';
import { TableVisualization } from 'reporting-visualizations/visualizations/table/tableRecords';
import { quotaViz, forecastViz, IntraPeriodVisualization, forecastManualSubmissionLayer } from './visualization';
import { tooltipFormatter } from './tooltip';
import { isTable, isTimeSeries, isSearch, isReportAccumulative } from '../lib/salesAnalytics/helpers';
import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { getDrilldownColumns } from '../lib/salesAnalytics/drilldownColumns';
import { getTableColumns } from './tableColumns';
import { DataLabelFormats } from 'reporting-visualizations/visualizations/commonRecords';
import { jsx as _jsx } from "react/jsx-runtime";
const chartViz = (report, data, {
  onDrilldown
}) => {
  const onPointClick = callWidgetDrilldown(report, onDrilldown);
  const isForecastReport = report.getIn(['config', 'dimensions']).includes('hs_manual_forecast_category');
  if (isReportAccumulative(report)) {
    return IntraPeriodVisualization({
      report,
      data
    })
    // The need of the gate kinda messes up the logic, so we will need to delete this and move the layer into the IntraPeriodVisualization as soon as this is fully ungated.
    .update('layers', layers => isForecastReport && isTimeSeries(report) ? layers.push(forecastManualSubmissionLayer(report)) : layers).set('events', {
      onPointClick
    }).setIn(['style', 'tooltipFormatter'], tooltipFormatter && tooltipFormatter({
      report,
      datasets: data
    }));
  }
  return inferVisualization(report, data).setIn(['data', 'quota'], data.getIn(['quota', 'data'])).update('layers', layers => layers.push(quotaViz(report)).concat(isForecastReport ? [forecastViz(report)] : [])).deleteIn(['layers', 0, 'color', 'order']).set('events', {
    onPointClick
  }).setIn(['style', 'tooltipFormatter'], tooltipFormatter && tooltipFormatter({
    report,
    datasets: data
  })).setIn(['style', 'dataLabelFormat'], DataLabelFormats.Y);
};
const tableViz = (report, data, {
  onDrilldown
}) => {
  const {
    data: primaryData,
    columns
  } = getTableColumns(report, data, onDrilldown);
  if (isTimeSeries(report)) {
    return TransposedTableVisualization({
      data: data.map(dataset => dataset.get('data')),
      transpose: {
        field: 'closedate',
        rows: columns,
        rowsByField: report.getIn(['config', 'dimensions', 1])
      }
    });
  }
  return TableVisualization({
    data: {
      primary: primaryData.getIn(['primary', 'data'])
    },
    columns
  });
};
const drilldownViz = (report, data) => TableVisualization({
  data: {
    primary: data.getIn(['primary', 'data'])
  },
  columns: getDrilldownColumns(report)
});
const getVisualization = (report, data, props) => isSearch(report) ? drilldownViz(report, data, props) : isTable(report) ? tableViz(report, data, props) : chartViz(report, data, props);
const Index = props => {
  return /*#__PURE__*/_jsx(SalesAnalyticsReport, Object.assign({}, props, {
    resolveReport: resolveReport,
    getVisualization: getVisualization
  }));
};
export default Index;